import { STORAGE_AUTH_TOKEN } from 'constants/store';

/* eslint-disable import/prefer-default-export */
export const getTokenFromStorage = () => {
    const token = localStorage.getItem(STORAGE_AUTH_TOKEN);
    return token ? JSON.parse(token) : '';
};
